


export function hasError<TErr, TTouch>({errors, touched, name} : {errors: TErr, touched: TTouch, name: keyof TErr & keyof TTouch}) {

    return (errors[name] && touched[name])

}
